import React from 'react';
import { Frame } from './Frame';
import { LogoMarquee } from './LogoMarquee';
import { clients } from '../data/clients';
export function ClientStrip() {
  return <section aria-labelledby="clients-title" data-id="element-86" data-mp="17q0iaoamoo5e">
      <Frame data-id="element-87" data-mp="ttlv44ji4n6g">
        <div className="pb-16 pt-8 md:px-6 md:pb-24 md:pt-10" data-id="element-88" data-mp="tu53atjcnx7a">
          <h2 id="clients-title" className="sr-only" data-id="element-89" data-mp="yr5ax8vul80i">
            Kunden
          </h2>
          <ul className="sr-only" data-id="element-90" data-mp="1mhhs7aczgh3r">
            {clients.map(c => <li key={c.id} data-id="element-91" data-mp="1mjcb6j4p1z57">{c.name}</li>)}
          </ul>
          <LogoMarquee data-id="element-92" data-mp="1rf16ubdlevw8" />
        </div>
      </Frame>
    </section>;
}